import { render, staticRenderFns } from "./PraticalDetail.vue?vue&type=template&id=df420610&scoped=true&"
import script from "./PraticalDetail.vue?vue&type=script&lang=js&"
export * from "./PraticalDetail.vue?vue&type=script&lang=js&"
import style0 from "./PraticalDetail.vue?vue&type=style&index=0&id=df420610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df420610",
  null
  
)

export default component.exports